export default {
  title: 'Security questions',
  informationsLabel: 'Your answers must be 4 to 25 characters long, consist of numbers or letters, without accents or special characters.',
};
